<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Sell Equity</v-toolbar-title>
    <v-spacer/>
    <span class="white--text caption font-weight-normal mr-3">Transacting Currency: {{Currency[0].CurrencyName}}</span>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="create">
    <v-row>
      <v-col cols="8">
        <v-card class="pt-3" elevation="12">
          <v-row class="px-3" no-gutters>
            <v-col class="pb-0 pt-0">
              <v-checkbox @change="getCharges(TotalValue); getAccounts(EquitySale.sale.CustodialID); EquitySale.deduction = []" hide-details class="mb-4" light v-model="Taxable" label="Taxable"></v-checkbox>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-checkbox @change="retrieveSettlementDetails(currentSystemDate.DayDate)" hide-details class="mb-4" light v-model="ListedCounters" label="Public Counters"></v-checkbox>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-checkbox hide-details class="mb-4" light v-model="EquitySale.sale.IsBookOver" label="Bookover"></v-checkbox>
            </v-col>
            <!-- <v-col class="pb-0 pt-0">
              <v-checkbox hide-details class="mb-4" light v-model="EquitySale.sale.WaiverBasicCharges" label="Waiver B/Charges"></v-checkbox>
            </v-col> -->
          </v-row>

          <v-row class="ml-1 mr-1">
            <v-col class="pb-0">
              <v-select
                outlined dense @change="getBalances(EquitySale.sale.CustodialID); getAccounts(EquitySale.sale.CustodialID); getHoldingUnits(EquitySale.sale); EquitySale.deduction = []"
                v-model="EquitySale.sale.CustodialID"
                :items="DealCustodians"
                item-text="CustodianName"
                item-value="CustodianID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Custodian"
              ></v-select>
              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    :value="balances.Available != null? (Number(balances.Available) + Number(EquitySale.sale.InstrumentValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Available Balance"
                    readonly class="pb-0"
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    :value="balances.Actual != null? Number(balances.Actual).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Actual Balance"
                    readonly
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-select
                @change="getHoldingUnits(EquitySale.sale); getAccounts(EquitySale.sale.CustodialID)"
                outlined dense
                v-model="EquitySale.sale.InstrumentID"
                :items="ListedCounters == true? allCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0) : allUnlistedCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="EquityCode"
                item-value="EquityID"
                placeholder="----"
                :rules="TextFieldRules"
                :label="ListedCounters == true? 'Public Counters' : 'Private Counters'"
              ></v-select>
              <v-select
                outlined dense
                v-model="EquitySale.sale.BuyerID"
                :items="allCounterparties.filter(a => a.IsBroker == true && a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="CounterPartyName"
                item-value="CounterPartyID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Broker"
              ></v-select>
            </v-col>
            <v-col class="pb-0">

              <v-text-field
                :value="currentSystemDate.DayDate"
                label="Sale Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                dense outlined color="#2A353D"
              ></v-text-field>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="SettlementDays"
                @input="retrieveSettlementDetails(currentSystemDate.DayDate)"
                label="Settlement Days"
                required type="number"
                placeholder="----"
                v-if="ListedCounters != true"
                :rules="TextFieldRules"
              ></v-text-field>

              <v-text-field
                v-model="SettlementDate"
                :label="SettlementDetails == ''? 'Settlement Date' : SettlementDays + ` ` + 'Days to settle'"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
              ></v-text-field>

              <!-- <v-menu
                ref="menu_2"
                v-model="menu_2"
                :close-on-content-click="false"
                :return-value.sync="ConfirmationDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="ConfirmationDate"
                    label="Confirmation Date"
                    append-icon="mdi-calendar-month"
                    readonly placeholder="--/--/--"
                    dense outlined color="#2A353D"
                    :error-messages="errors"
                    :rules="CreateDateRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker color="#2A353D" v-model="ConfirmationDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn outlined small color="#2A353D" @click="menu_2 = false">Cancel</v-btn>
                <v-btn outlined small color="#2A353D" @click="$refs.menu_2.save(ConfirmationDate)">OK</v-btn>
                </v-date-picker>
              </v-menu> -->
              <v-text-field
                label="Current Holding"
                :value="Number(HoldingUnits).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})"
                readonly placeholder="----"
                dense outlined color="#2A353D"
              ></v-text-field>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="EquitySale.sale.BrokerNote"
                label="Broker Note"
                required :error-messages="BNerrors"
                placeholder="----"
                :rules="[
                  v => !!v || 'field is required',
                  v => (v && v.length <= 50) || 'field must be less than 50 characters'
                ]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-1 mr-1">
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="EquitySale.sale.Quantity"
                label="Quantity"
                required
                type="number"
                :rules="QuantityRules"
                placeholder="----"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="EquitySale.sale.UnitPrice"
                label="Unit Price"
                required
                type="number"
                :rules="TextFieldRules"
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="EquitySale.sale.Quantity != null && EquitySale.sale.UnitPrice != null? Number(getTotalValue(EquitySale.sale)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                label="Total Value"
                readonly
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="EquitySale.sale.Quantity != null && EquitySale.sale.UnitPrice != null ? Number(getNetConsideration(EquitySale.sale)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                label="Net Consideration"
                readonly placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-data-table
          :headers="charges_headers"
          :fixed-header="true"
          :height="ListedCounters == true? 179 : 212"
          :items="ChargesApplied"
          disable-pagination
          hide-default-footer
          class="mb-2 elevation-12"
        >
          <template v-slot:top>
            <v-row>
              <v-col class="pb-0 pt-0">
                <span class="black--text caption font-weight-bold ml-4">Total Charges Applied:</span>
              </v-col>
              <v-col class="pb-0 pt-0 mr-4 text-right">
                <span v-if="TotalValue != null" class="black--text caption font-weight-bold ml-4">{{Number(getTotalCharges()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.Charge="{ item }">
            {{Number(item.Charge).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>

        </v-data-table>
        <v-data-table
          :headers="taxes_headers"
          :fixed-header="true"
          :height="ListedCounters == true? 179 : 212"
          :items="TaxesApplied"
          disable-pagination
          hide-default-footer
          class="mb-2 elevation-12 mt-3"
        >
          <template v-slot:top >
            <v-row>
              <v-col class="pb-0 pt-0">
                <span class="black--text caption font-weight-bold ml-4">Total Taxes Applied:</span>
              </v-col>
              <v-col class="pb-0 pt-0 mr-4 text-right">
                <span v-if="TotalValue != null" class="black--text caption font-weight-bold ml-4">{{Number(getTotalVAT()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.Amount="{ item }">
            {{Number(item.Amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>

        </v-data-table>
      </v-col>
    </v-row>

    <v-data-table
      :headers="deductions_headers"
      :fixed-header="true"
      :items="EquitySale.deduction"
      disable-pagination
      hide-default-footer dense
      class="elevation-12 my-allocations-table mt-3"
    >

      <template v-slot:top >
        <v-toolbar dense flat>
          <v-toolbar-title class="grey--text caption font-weight-normal">Allocations</v-toolbar-title>
          <v-spacer/>
          <v-btn class="text-right" @click="NewDeduction(EquitySale.deduction)" x-small dark outlined fab color="#2A353D">
            <v-icon small >mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.AccountID="{ item }">
        <v-select
          @change="getAccHoldingUnits(item, EquitySale.sale)"
          @click="setActiveDeduction(item, index)"
          background-color="#ffffff00"
          v-model="item.AccountID"
          :items="Accounts"
          :menu-props="{ top: true, offsetY: true }"
          item-text="AccountName"
          item-value="AccountID"
          solo flat class="Account ma-0 pa-0 pt-5"
          placeholder="----" dense
          :rules="[
            v => !!v || 'field is required',
            v => EquitySale.deduction.filter(a => a.AccountID == item.AccountID).length < 2 || 'Account already selected'
          ]"
        ></v-select>
      </template>

      <template v-slot:item.OpeningBalance="{ item }">
        {{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})}}
      </template>

      <template v-slot:item.ClosingBalance="{ item }">
        {{Number(getClosingBalance(item)).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})}}
      </template>

      <template v-slot:item.ChargeValue="{ item }">
        {{Number(getDeductionChargeValue(item, EquitySale.sale)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.UnitPrice="{ item }">
        {{Number(getDeductionUnitPrice(item, EquitySale.sale)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.DeductionValue="{ item }">
        {{Number(getDeductionValue(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template  v-slot:item.Quantity="{ item }">
        <v-text-field
          v-model="item.Quantity"
          label="Quantity"
          :rules="[
            v => !!v || 'field is required',
            v =>  v <= Number(item.OpeningBalance) || 'Over allocated',
          ]"
          single-line
          type="number"
        ></v-text-field>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon small @click="removeDeduction(item, EquitySale.deduction)">mdi-close</v-icon>
      </template>

      <template v-slot:footer >
        <v-divider class="mt-0"/>
        <v-row class="ml-2 mr-2">
          <v-col class="pb-0 pt-7" cols="2">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getDeductedValue(EquitySale.deduction)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            color="#2A353D"
            label="Allocated Value"
            readonly
            :rules="[() => getDeductedValue(EquitySale.deduction) == TotalValue || 'should match Deal Value']"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getDeductedUnits(EquitySale.deduction)).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})"
            color="#2A353D"
            label="Deducted Units"
            readonly
            :rules="[() => getDeductedUnits(EquitySale.deduction) == EquitySale.sale.Quantity || 'should match Deal Quantity']"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="EquitySale.sale.Quantity != null ? Number(EquitySale.sale.Quantity - getDeductedUnits(EquitySale.deduction)).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}) : 0"
            color="#2A353D"
            label="Remaining Units"
            readonly
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7" cols="6">
            <div class="text-right mb-4 mt-4">
              <v-btn class="white--text mr-4" small color="#2A353D" @click="closeCreate()">close</v-btn>
              <v-btn class="white--text" small color="#2A353D" :disabled="!valid || loading == true" @click="createNew()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                submit
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </v-form>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="edit" >
    <span class="d-flex flex-row mt-2">
      <span class="grey--text caption font-weight-normal">REFERENCE: <span class="subtitle-2">{{currentSale.DealNumber}}</span></span>
      <v-spacer/>
      <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSale.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      <span v-if="currentSale.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSale.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSale.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
    </span>
    <v-row>
      <v-col cols="8">
        <v-card class="pt-3" elevation="12">
          <v-row class="px-3" no-gutters>
            <v-col class="pb-0 pt-0">
              <v-checkbox @change="getCharges(TotalValue); getAccounts(currentSale.CustodialID); currentSale.deductions = []" hide-details class="mb-4" light v-model="Taxable" label="Taxable"></v-checkbox>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-checkbox @change="retrieveSettlementDetails(currentSale.SaleDate)" hide-details class="mb-4" light v-model="ListedCounters" label="Public Counters"></v-checkbox>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-checkbox hide-details class="mb-4" light v-model="currentSale.IsBookOver" label="Bookover"></v-checkbox>
            </v-col>
            <!-- <v-col class="pb-0 pt-0">
              <v-checkbox hide-details class="mb-4" light v-model="currentSale.WaiverBasicCharges" label="Waiver B/Charges"></v-checkbox>
            </v-col> -->
          </v-row>

          <v-row class="ml-1 mr-1">
            <v-col class="pb-0">
              <v-select
                outlined dense @change="getBalances(currentSale.CustodialID); getAccounts(currentSale.CustodialID); getHoldingUnits(currentSale); currentSale.deductions = []"
                v-model="currentSale.CustodialID"
                :items="DealCustodians"
                item-text="CustodianName"
                item-value="CustodianID"
                placeholder="----"
                :readonly="view"
                :rules="TextFieldRules"
                label="Custodian"
              ></v-select>
              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field v-if="!view"
                    light dense outlined
                    :value="balances.Available != null? (Number(balances.Available) + Number(currentSale.InstrumentValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Available Balance"
                    readonly class="pb-0"
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                  <v-text-field v-else
                    light dense outlined
                    v-model="currentSale.AvailAtTxn"
                    color="#2A353D"
                    label="Available Balance"
                    readonly class="pb-0"
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-text-field v-if="!view"
                    light dense outlined
                    :value="balances.Actual != null? Number(balances.Actual).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Actual Balance"
                    readonly
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                  <v-text-field v-else
                    light dense outlined
                    v-model="currentSale.ActualAtTxn"
                    color="#2A353D"
                    label="Actual Balance"
                    readonly
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-select
                outlined dense @change="getHoldingUnits(currentSale); getAccounts(currentSale.CustodialID)"
                v-model="currentSale.InstrumentID"
                :items="ListedCounters == true? allCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0) : allUnlistedCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="EquityCode"
                item-value="EquityID"
                placeholder="----"
                :readonly="view"
                :rules="TextFieldRules"
                :label="ListedCounters == true? 'Public Counters' : 'Private Counters'"
              ></v-select>

              <v-select
                outlined dense
                v-model="currentSale.BuyerID"
                :items="allCounterparties.filter(a => a.IsBroker == true && a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="CounterPartyName"
                item-value="CounterPartyID"
                placeholder="----"
                :readonly="view"
                :rules="TextFieldRules"
                label="Broker"
              ></v-select>
            </v-col>
            <v-col class="pb-0">

              <v-text-field
                v-model="currentSale.SaleDate"
                label="sale Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                dense outlined color="#2A353D"
                :disabled="view"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="SettlementDays"
                @input="retrieveSettlementDetails(currentSale.SaleDate)"
                label="Settlement Days"
                required type="number"
                :readonly="view"
                placeholder="----"
                v-if="ListedCounters != true"
                :rules="TextFieldRules"
              ></v-text-field>

              <v-text-field v-if="!view"
                v-model="SettlementDate"
                :label="SettlementDetails == ''? 'Settlement Date' : SettlementDays + ` ` + 'Days to settle'"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
              ></v-text-field>
              <v-text-field v-else
                v-model="currentSale.SettlementDate"
                label="Settlement Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
              ></v-text-field>

              <!-- <v-menu
                ref="menu_2"
                v-model="menu_2"
                :close-on-content-click="false"
                :return-value.sync="ConfirmationDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="ConfirmationDate"
                    label="Confirmation Date"
                    append-icon="mdi-calendar-month"
                    readonly placeholder="--/--/--"
                    :disabled="view"
                    dense outlined color="#2A353D"
                    :error-messages="errors"
                    :rules="EditDateRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker color="#2A353D" v-model="ConfirmationDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn outlined small color="#2A353D" @click="menu_2 = false">Cancel</v-btn>
                <v-btn outlined small color="#2A353D" @click="$refs.menu_2.save(ConfirmationDate)">OK</v-btn>
                </v-date-picker>
              </v-menu> -->

              <v-text-field
                label="Current Holding"
                :value="Number(HoldingUnits).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})"
                readonly placeholder="----"
                dense outlined color="#2A353D"
              ></v-text-field>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="currentSale.BrokerNote"
                label="Broker Note"
                required
                readonly
                placeholder="----"
                :rules="[
                  v => !!v || 'field is required',
                  v => (v && v.length <= 50) || 'field must be less than 50 characters'
                ]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-1 mr-1">
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="currentSale.Quantity"
                label="Quantity"
                required
                type="number"
                :readonly="view"
                :rules="TextFieldRules"
                placeholder="----"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="currentSale.UnitPrice"
                label="Unit Price"
                required
                type="number"
                :readonly="view"
                :rules="TextFieldRules"
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="currentSale.Quantity != null && currentSale.UnitPrice != null? Number(getTotalValue(currentSale)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                label="Total Value"
                readonly
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="currentSale.Quantity != null && currentSale.UnitPrice != null ? Number(getNetConsideration(currentSale)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                label="Net Consideration"
                readonly placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>              
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-data-table
          :headers="view == true ? view_charges_headers : charges_headers"
          :fixed-header="true"
          :height="ListedCounters == true? 179 : 212"
          :items="view == true ? currentSale.charges : ChargesApplied"
          disable-pagination
          hide-default-footer
          class="mb-2 elevation-12"
        >
          <template v-slot:top >
            <v-row>
              <v-col class="pb-0 pt-0">
                <span class="black--text caption font-weight-bold ml-4">Total Charges Applied:</span>
              </v-col>
              <v-col class="pb-0 pt-0 mr-4 text-right">
                <span v-if="currentSale.charges != null" class="black--text caption font-weight-bold ml-4">{{Number(getTotalCharges()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
              </v-col>
            </v-row>
          </template>

          <template v-if="view" v-slot:item.TransactionChargeID="{ item }">
            {{allTransactionCharges.filter(a => a.TransactionChargeID == item.TransactionChargeID).map(a => a.TransactionChargeCode)[0]}}
          </template>

          <template v-if="!view" v-slot:item.Charge="{ item }">
            {{Number(item.Charge).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>

        </v-data-table>
        <v-data-table
          :headers="view == true ? view_taxes_headers : taxes_headers"
          :fixed-header="true"
          :height="ListedCounters == true? 179 : 212"
          :items="view == true ? currentSale.taxes : TaxesApplied"
          disable-pagination
          hide-default-footer
          class="mb-2 elevation-12 mt-3"
        >
          <template v-slot:top >
            <v-row>
              <v-col class="pb-0 pt-0">
                <span class="black--text caption font-weight-bold ml-4">Total Taxes Applied:</span>
              </v-col>
              <v-col class="pb-0 pt-0 mr-4 text-right">
                <span v-if="currentSale.charges != null" class="black--text caption font-weight-bold ml-4">{{Number(getTotalVAT()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
              </v-col>
            </v-row>
          </template>

          <template v-if="view" v-slot:item.TransactionChargeID="{ item }">
            {{allTransactionCharges.filter(a => a.TransactionChargeID == item.TransactionChargeID).map(a => a.TransactionChargeCode)[0]}}
          </template>

          <template v-if="!view" v-slot:item.Amount="{ item }">
            {{Number(item.Amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>

        </v-data-table>
      </v-col>
    </v-row>

    <v-data-table
      :headers="deductions_headers"
      :fixed-header="true"
      :items="currentSale.deductions"
      disable-pagination
      hide-default-footer dense
      class="elevation-12 my-allocations-table mt-3"
    >

      <template v-slot:top >
        <v-toolbar dense flat>
          <v-toolbar-title class="grey--text caption font-weight-normal">Allocations</v-toolbar-title>
          <v-spacer/>
          <v-btn :disabled="view" class="text-right" @click="NewDeduction(currentSale.deductions)" x-small dark outlined fab color="#2A353D">
            <v-icon small >mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.AccountID="{ item }">
        <v-select
          @change="getAccHoldingUnits(item, currentSale)"
          @click="setActiveDeduction(item, index)"
          background-color="#ffffff00"
          v-model="item.AccountID"
          :items="Accounts"
          :menu-props="{ top: true, offsetY: true }"
          :readonly="view"
          item-text="AccountName"
          item-value="AccountID"
          solo flat class="Account ma-0 pa-0 pt-5"
          placeholder="----" dense
          :rules="[
            v => !!v || 'field is required',
            v => currentSale.deductions.filter(a => a.AccountID == item.AccountID).length < 2 || 'Account already selected'
          ]"
        ></v-select>
      </template>

      <template v-slot:item.OpeningBalance="{ item }">
        <span v-if="!view">{{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})}}</span>
        <span v-else>{{item.OpeningBalance}}</span>
      </template>

      <template v-slot:item.ClosingBalance="{ item }">
        <span v-if="!view">{{Number(getClosingBalance(item)).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})}}</span>
        <span v-else>{{item.ClosingBalance}}</span>
      </template>

      <template v-slot:item.ChargeValue="{ item }">
        {{Number(getDeductionChargeValue(item, currentSale)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.UnitPrice="{ item }">
        {{Number(getDeductionUnitPrice(item, currentSale)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.DeductionValue="{ item }">
        {{Number(getDeductionValue(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template  v-slot:item.Quantity="{ item }">
        <v-text-field
          v-model="item.Quantity"
          label="Quantity"
          :rules="view ? [] : item.OpeningBalance != null ? [
            v => !!v || 'field is required',
            v =>  v <= item.OpeningBalance || 'Over allocated',
          ] : []"
          single-line
          :readonly="view"
          type="number"
        ></v-text-field>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon v-if="!view" small @click="removeDeduction(item, currentSale.deductions)">mdi-close</v-icon>
      </template>

      <template v-slot:footer >
        <v-divider class="mt-0"/>
        <v-row class="ml-2 mr-2">
          <v-col class="pb-0 pt-7" cols="2">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getDeductedValue(currentSale.deductions)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            color="#2A353D"
            label="Allocated Value"
            readonly
            :rules="[() => getDeductedValue(currentSale.deductions) == TotalValue || 'should match Deal Value']"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getDeductedUnits(currentSale.deductions)).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})"
            color="#2A353D"
            label="Units to be sold"
            readonly
            :rules="[() => getDeductedUnits(currentSale.deductions) == currentSale.Quantity || 'should match Deal Quantity']"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="currentSale.Quantity != null ? Number(currentSale.Quantity - getDeductedUnits(currentSale.deductions)).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}) : 0"
            color="#2A353D"
            label="Remaining Units"
            readonly
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7" cols="6">
            <div class="text-right mb-4 mt-4">
              <v-btn class="white--text mr-4" small color="#2A353D" @click="view = false, closeEdit()">close</v-btn>
              <v-btn class="white--text" v-if="!view" small color="#2A353D" :disabled="!valid || loading == true" @click="update()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                save
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </v-form>

<!-- ********************************************************************************************TABLE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    :headers="headers"
    :fixed-header="true"
    :items="confirmedSales ? sales : sales.filter(a => a.CheckerID === 0)"
    :search="search" v-if="!create &&  !edit"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >

      <v-dialog persistent v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="close()">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus('', false); close()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                ok
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="reverseDialog" max-width="500px">
        <v-form flat ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="grey--text text-center">Deal Reversal</span>
            </v-card-title>

            <v-card-text>
              <span class="subtitle-1">{{reversal_description}}</span>

              <v-textarea
                class="mt-3"
                label="Reversal Reason"
                v-model="ReversalReason"
                outlined rows="6"
                row-height="15"
                :rules="TextFieldRules"
                placeholder="----"
              ></v-textarea>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-right mb-4">
                <v-btn class="white--text mr-3" small color="#2A353D" @click="reverseDialog = false">cancel</v-btn>
                <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="ReverseDeal()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  submit
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>          
        </v-form>
      </v-dialog>

      <v-container row>

        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true && DealerID > 0" v-show="confirmedSales" @click="overlay = true; showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-show="confirmedSales" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Equity Sales.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Equity Sales.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-show="confirmedSales" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency); getCustodians()">

          <v-list-item-title>
            {{ Currency.CurrencyName }}
          </v-list-item-title>

          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-show="!confirmedSales" @click="confirmedSales = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0 && item.IsReversed == 0">rejected</v-chip>
      <v-chip outlined small color="error" v-if="item.IsReversed == 1">reversed</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0 && item.IsReversed == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0 && item.IsReversed == 0">confirmed</v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedSales && item.CheckerID == 0" top>

      </v-tooltip>
      <v-tooltip v-if="!confirmedSales && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="updateStatus(item, true)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedSales && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="reject(); setActiveSale(item, index)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedSales && DealerID > 0"
        small outlined v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActiveSale(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
      <v-btn
        small outlined
        @click="view = true; setActiveSale(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-tooltip v-if="confirmedSales" top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            :disabled="showReverseBtn == true && item.CheckerID == 0 ? false : true"
            color="#2A353D" @click="setActiveSale(item, index); initReversal(item)"
          >
          mdi-backup-restore
          </v-icon>
        </template>
        <span>reverse</span>
      </v-tooltip>
    </template>

    <template v-slot:item.CustodialID="{ item }">
      {{getCustodianName(item.CustodialID)}}
    </template>

    <template v-slot:item.AccountID="{ item }">
      {{getAccountName(item.AccountID)}}
    </template>

    <template v-slot:item.SaleDate="{ item }">
      {{ item.SaleDate | moment("DD MMM YYYY") }}
    </template> 

    <!-- <template v-slot:item.ValueDate="{ item }">
      {{ item.ValueDate | moment("DD MMM YYYY") }}
    </template>  -->

    <!-- <template v-slot:item.MakeDate="{ item }">
      {{ item.MakeDate | moment("DD MMMM YYYY") }}
    </template> -->

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import dealingService from '../services/dealing.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  name: 'sale_equtiy',

  data () {
    return {
      confirmedSales: true,
      edit: false,
      create:false,
      view: false,
      message: '',
      menu: false,
      menu_1: false,
      menu_2: false,
      dialog: false,
      overlay: false,
      ListedCounters: true,
      SettlementDays: 0,
      SettlementDate: '',
      ConfirmationDate: '',
      HoldingUnits: 0,
      loading: false,
      Taxable: false,
      permitted: null,
      permitted_dialog: true,
      reverseDialog: false,
      ReversalReason: '',
      reversal_description: '',
      search: '',
      valid: true,
      content: '',
      EquityQuantity: '',
      currentDeduction: null,
      deductionIndex: -1,
      currentSale: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Broker Note',
          align: 'start',
          sortable: true,
          value: 'BrokerNote'
        },
        { text: 'Custodian', value: 'CustodialID', sortable: false },
        { text: 'Sale Date', value: 'SaleDate', sortable: true },
        // { text: 'Value Date', value: 'ValueDate', sortable: true },
        // { text: 'Deposit Method', value: 'DepositMethodID', sortable: true },
        // { text: 'Date Created', value: 'MakeDate', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      CreateDateRules: [
        v => !!v || 'field is required',
        v => (v <= this.currentSystemDate.DayDate) || 'Date must not exceed Sale Date'
      ],
      EditDateRules: [
        v => !!v || 'field is required',
        v => (v <= this.currentSale.SaleDate) || 'Date must not exceed Sale Date'
      ],
      QuantityRules: [
        v => !!v || 'field is required',
        v => (!!v && v <= this.HoldingUnits) || 'Value exceeds Units Held',
      ],
      DeductedValueRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.TotalValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
      ],
      DeductedUnitsRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.EquitySale.sale.Quantity).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})) || 'should match Deal Quantity',
      ],
      EditDeductedValueRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.TotalValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
      ],
      EditDeductedUnitsRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.currentSale.Quantity).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})) || 'should match Deal Quantity',
      ],
      view_charges_headers: [
        { text: 'Charge Name', value: 'TransactionChargeID', sortable: false },
        { text: 'Amt', value: 'Amount', sortable: false },
      ],
      charges_headers: [
        { text: 'Charge Name', value: 'TransactionCharge', sortable: false },
        { text: 'Amt', value: 'Charge', sortable: false },
      ],
      ChargesApplied: [],
      view_taxes_headers: [
        { text: 'Tax Name', value: 'TransactionChargeID', sortable: false },
        { text: 'Amt', value: 'Amount', sortable: false },
      ],
      taxes_headers: [
        { text: 'Tax Name', value: 'Charge', sortable: false },
        { text: 'Amt', value: 'Amount', sortable: false },
      ],
      TaxesApplied: [],
      deductions_headers: [
        { text: 'Account Name', value: 'AccountID', sortable: false, width: 300 },
        { text: 'Sell', value: 'Quantity', sortable: false },
        { text: 'Unit price', value: 'UnitPrice', sortable: false },
        { text: 'Sale Value', value: 'DeductionValue', sortable: false, width: 100  },
        { text: 'Holding (units)', value: 'OpeningBalance', sortable: false },
        { text: 'Closing Holding (units)', value: 'ClosingBalance', sortable: false },
        { value: 'action', sortable: false }
      ],
      balances: {},
      CurrencyId: 2,
      DealCustodians: [],
      Accounts: [],
      UnitPrice: 0,
      TotalValue: 0,
      RejectionStatus: 0,
      EquitySale: {
        sale: {
          InstrumentValue: 0
        },
        deduction: [],
        charges: [],
        taxes: [],
      },
      errors: [],
      BNerrors: [],
    }
  },

  computed: {
    ...mapGetters([
      "allEquitySales",
      "allApplicationDefaults",
      "allCurrencies",
      "allAssetTypes",
      "allRejectionReasons",
      "allCounters",
      "allUnlistedCounters",
      "allCounterparties",
      "allBondInvestmentTypes",
      "allDealers",
      "allUsers",
      "allTransactionCharges",
      "allTaxes",
      "currentSystemDate",
      "allConfirmationSettings"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },
    sales() {
      return this.allEquitySales.filter(a => a.CurrencyID == this.CurrencyId);
    },
    Currency() {
      return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
    },
    DealerID() {
      return this.allDealers.filter(a => a.SystemUserID == this.currentUser.SecurityUserID).map(a => a.DealerID).toLocaleString();
    },
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 201).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 201).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 201).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    showReverseBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 201).map(r => r.AllowReversal)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 201).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  watch: {
    TotalValue: function(newValue) {
      this.getCharges(newValue),
      this.getTaxes(newValue)
    },
    ConfirmationDate: function(newValue) {
      if(newValue != null && newValue != ''){
        var data = {
          Date: newValue,
        };

        dealingService.checkIsWeekendHoliday(data)
        .then(response => {
          this.errors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
        })        
      }
    },
    'EquitySale.sale.BrokerNote': {
      handler: function(newValue) {
        if(newValue != null && newValue != ''){
          var data = {
            BrokerNote: newValue,
          };

          dealingService.checkBrokerNoteIsUnique(data)
          .then(response => {
            this.BNerrors = response.data[0].IsUnique ? [] : ['Broker Note already in use']
          })
        }
      },
      deep: true
    },
    'currentSale.SaleID': {
      handler: function() {
        // this.currentSale.Quantity = Number(this.currentSale.Quantity.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}))

        if (this.currentSale.InstrumentID >= 9000){
          this.ListedCounters = false
        }

        this.Taxable = !!this.currentSale.IsTaxable
        this.ConfirmationDate = this.currentSale.DealConfirmationDate

        if(this.view != true){
          for (let i = 0; i < this.currentSale.deductions.length; i++) {
            this.getAccHoldingUnits(this.currentSale.deductions[i], this.currentSale)
          }
        }

        // for (let t = 0; t < this.currentSale.deductions.length; t++) {
        //   this.currentSale.deductions[t].Quantity = Number(this.currentSale.deductions[t].Quantity.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}))
        // }
      },
      deep: true
    }
  },

  created () {
    this.CurrencyId = this.allApplicationDefaults[0].CurrencyID;
    this.getCustodians();
  },

  methods: {
    ...mapActions([
      "createSale",
      "updateSale",
      "updateSaleStatus",
      "createReversal"
    ]),

     async createNew() {
      this.message = '';

      await this.validate()

      if (this.valid == true) {
        this.loading = true;
        this.EquitySale.sale.MakerID = this.currentUser.SecurityUserID,
        this.EquitySale.sale.CheckerID = this.CheckerID,
        this.EquitySale.sale.CurrencyID = this.CurrencyId,
        this.EquitySale.sale.DealerID = this.DealerID,
        this.EquitySale.sale.SaleDate = this.currentSystemDate.DayDate,
        this.EquitySale.sale.IsTaxable = this.Taxable,
        this.EquitySale.sale.SettlementDate = this.SettlementDate,
        // this.EquitySale.sale.DealConfirmationDate = this.ConfirmationDate,
        this.EquitySale.sale.Tax = this.getTotalVAT(),
        this.EquitySale.sale.LastUserID = this.currentUser.SecurityUserID,
        this.EquitySale.sale.AssetType = 2,
        this.EquitySale.sale.AvailAtTxn = Number(this.balances.Available) + Number(this.EquitySale.sale.InstrumentValue),
        this.EquitySale.sale.ActualAtTxn = this.balances.Actual,
        this.EquitySale.sale.FldBit01 = 0,

        this.EquitySale.charges = this.ChargesApplied,
        this.EquitySale.taxes = this.TaxesApplied,

        this.createSale(this.EquitySale)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newSale',
            data: response.data
          });
          this.message = response.data.message
          this.loading = false;
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        }) 
      }
    },

    async update() {
      this.message = '';

      await this.validate()

      if (this.valid == true) {
        this.loading = true;
        this.currentSale.AvailAtTxn = Number(this.balances.Available) + Number(this.currentSale.InstrumentValue),
        this.currentSale.ActualAtTxn = this.balances.Actual,
        this.currentSale.CurrencyID = this.CurrencyId,
        this.currentSale.DealerID = this.DealerID,
        this.currentSale.SettlementDate = this.SettlementDate,
        // this.currentSale.DealConfirmationDate = this.ConfirmationDate,
        this.currentSale.Tax = this.getTotalVAT(),
        this.currentSale.MakerID = this.currentUser.SecurityUserID,
        this.currentSale.LastUserID = this.currentUser.SecurityUserID,
        this.currentSale.CheckerID = 0,
        this.currentSale.CheckDate = null,
        this.currentSale.MakeDate = new Date(),
        this.currentSale.RejectionID = this.RejectionStatus,

        this.currentSale.charges = this.ChargesApplied,
        this.currentSale.taxes = this.TaxesApplied

        this.updateSale(this.currentSale)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updSale',
            data: this.currentSale
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    updateStatus(item, status) {
      this.message = '';
      this.loading = true;

      if(status == true){
        item.CheckerID = this.currentUser.SecurityUserID,
        item.LastUserID = this.currentUser.SecurityUserID,
        item.CheckDate = new Date(),
        item.updatedAt = new Date(),
        item.RejectionID = this.RejectionStatus,
        item.IsConfirmation = status,

        this.updateSaleStatus(item)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updSale',
            data: item
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      } else {
        this.currentSale.CheckerID = this.currentUser.SecurityUserID,
        this.currentSale.LastUserID = this.currentUser.SecurityUserID,
        this.currentSale.CheckDate = new Date(),
        this.currentSale.updatedAt = new Date(),
        this.currentSale.RejectionID = this.RejectionStatus,
        this.currentSale.IsConfirmation = status,

        this.updateSaleStatus(this.currentSale)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updSale',
            data: this.currentSale
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    initReversal(item){
      var data = {
        FunctionID: 201,
        EntryID: item.SaleID,
        ReversalDate: this.currentSystemDate.DayDate
      }
      
      dealingService.initReversal(data)
      .then(response => {
        if(response.data.validation[0].fnResultClass == 1){
          this.reverseDialog = true
          this.reversal_description = response.data.description[0][0].description
        } else {
          this.message = response.data.validation[0].fnResult
        }
      })
    },

    async ReverseDeal(){
      this.message = '';
      await this.validate()

      if (this.valid == true) {
        var data = {
          ReversalID: 0,
          FunctionID: 201,
          EntityID: this.currentSale.SaleID,
          ReversalReason: this.ReversalReason,
          ReversalDate: this.currentSystemDate.DayDate,
          MakerID: this.currentUser.SecurityUserID,
          CheckerID: 0,
          LastUserID: this.currentUser.SecurityUserID,
          RejectionID: 0,
        }

        this.createReversal(data)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'newReversal',
            data: response.data
          });
          
          this.message = response.data.message
          this.loading = false;
          this.reverseDialog = false;
          this.reversal_description = '';
          this.ReversalReason = '';
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    getCustodians() {
      this.message = '';
      var data ={
        CurrencyID: this.CurrencyId,
      }
      dealingService.getCustodians(data.CurrencyID)
      .then(response => {
        this.DealCustodians = response.data
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getBalances(item) {
      this.message = '';
      var data ={
        CustodialID: item,
        EffectiveDate: this.currentSystemDate.DayDate,
        CurrencyID: this.CurrencyId
      }
      dealingService.getBalances(data.CustodialID, data)
      .then(response => {
        this.balances = response.data[0]
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getHoldingUnits(item) {
      var data = {
        CustodianID: item.CustodialID,
        InstrumentID: item.InstrumentID,
        EffectiveDate: this.currentSystemDate.DayDate,
        AssetType: 2
      }
      if (item.CustodialID != null && item.InstrumentID != null) {
        dealingService.getCustodianHolding(data)
        .then(response => {
          this.HoldingUnits = Number(response.data.map(r => r.UnitsHeld)[0])
          return this.HoldingUnits
        })
      }
    },

    getAccHoldingUnits(item, parent) {
      var data = {
        AccountID: item.AccountID,
        InstrumentID: parent.InstrumentID,
        EffectiveDate: this.currentSystemDate.DayDate,
        AssetType: 2
      }
      if (item.AccountID != null && parent.InstrumentID != null) {
        dealingService.getAccountHolding(data)
        .then(response => {
          item.OpeningBalance = Number(response.data.map(r => r.UnitsHeld)[0])
          return item.OpeningBalance
        })
      }
    },

    getCharges(item) {
      var data = {
        ModuleID: 1,
        FunctionID: 201,
        CurrencyID: this.CurrencyId,
        Amount: item,
        Taxable: !!this.Taxable
      };

      if (item != null) {
        dealingService.getTransactionCharges(data.ModuleID, data)
        .then(response => {
          this.ChargesApplied = response.data
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getTaxes(item) {
      var data = {
        ModuleID: 1,
        FunctionID: 201,
        CurrencyID: this.CurrencyId,
        Amount: item
      };

      if (item != null) {
        dealingService.getTransactionTaxes(data.ModuleID, data)
        .then(response => {
          this.TaxesApplied = response.data
          
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Equity Sales", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Equity Sales.pdf')
      }
    },

    getClosingBalance(item) {
      item.ClosingBalance = item.OpeningBalance - item.Quantity;
      return item.ClosingBalance
    },

    getDeductionUnitPrice(item, parent) {
      item.UnitPrice = parent.UnitPrice
      return item.UnitPrice
    },

    getDeductionValue(item) {
      item.DeductionValue = item.Quantity * item.UnitPrice;
      return item.DeductionValue
    },

    getDeductionChargeValue(item, parent) {
      item.ChargeValue = (item.Quantity / parent.Quantity) * (this.getTotalCharges() + this.getTotalVAT());
      return item.ChargeValue
    },

    getTotalCharges() {
      return this.ChargesApplied.map(a => Number(a.Charge)).reduce((a, b) => a + b, 0)
    },

    getTotalVAT() {
      return this.TaxesApplied.map(a => Number(a.Amount)).reduce((a, b) => a + b, 0)
    },

    retrieveSettlementDetails(item) {
      var data = {
        DealDate: item,
        Listed: !!this.ListedCounters,
        Days: this.SettlementDays
      }
      if (data.DealDate != null && data.Listed != null && data.Days != null) {
        dealingService.getSettlementDetails(data)
        .then(response => {
          this.SettlementDays = response.data[0].fnDaysToSettlement
          this.SettlementDate = response.data[0].fnSettlementDate
        })
      }
    },

    mapCurrency(currency) {
      return this.CurrencyId = currency.CurrencyID
    },

    allowedDates: val => val <= new Date().toISOString().split('T')[0],

    getCustodianName(id) {
      return this.DealCustodians.filter(a => a.CustodianID === id).map(a => a.CustodianName).toLocaleString()
    },

    getTotalValue(item) {
      this.TotalValue = item.Quantity * item.UnitPrice
      return this.TotalValue
    },

    getNetConsideration(item) {
      item.InstrumentValue = this.TotalValue - (this.getTotalCharges() + this.getTotalVAT())
      return item.InstrumentValue
    },

    getDeductedValue(item) {
      return item.map(i => Number(i.DeductionValue)).reduce((a, b) => a + b, 0);
    },

    getDeductedUnits(item) {
      return item.map(i => Number(i.Quantity)).reduce((a, b) => a + b, 0);
    },

    getAccounts(item) {
      var data = {
        CustodialID: item,
        CurrencyID: this.CurrencyId,
        Taxable: this.Taxable,
        Counter: this.EquitySale.sale.InstrumentID || this.currentSale.InstrumentID
      }
      if(item != null){
        dealingService.getCustodianAccounts(data.CustodialID, data)
        .then(response => {
          this.Accounts = response.data
        })
      }
    },

    NewDeduction(item) {
      item.push(
        {
          AccountID: null,
          OpeningBalance: '',
          DeductionValue: '',
          ChargeValue: '',
          Quantity: '',
          UnitPrice: '',
          ClosingBalance: ''
        }
      )
    },

    removeDeduction(item, parent) {
      const index = parent.findIndex(p => p.AccountID === item.AccountID);
      parent.splice(index, 1)
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedSales = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.currentSale = null,
      this.balances = {},
      this.HoldingUnits = 0,
      this.ChargesApplied = [],
      this.TaxesApplied = [],
      this.ListedCounters = true,
      this.SettlementDays = 0,
      this.SettlementDate = '',
      this.ConfirmationDate = '',
      this.TotalValue = 0,
      this.edit = false
    },

    showCreate () {
      this.create = true;
      this.retrieveSettlementDetails(this.currentSystemDate.DayDate)
    },

    closeCreate() {
      this.balances = {},
      this.HoldingUnits = 0,
      this.EquitySale.deduction = [],
      this.EquitySale.sale = {InstrumentValue: 0},
      this.ChargesApplied = [],
      this.TaxesApplied = [],
      this.ListedCounters = true,
      this.SettlementDays = 0,
      this.SettlementDate = '',
      this.ConfirmationDate = '',
      this.TotalValue = 0,
      this.create = false
    },

    reject () {
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.RejectionStatus = 0
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },

    async EditAllocation (item) {
      if(this.view != true){
        for (let i = 0; i < item.deductions.length; i++) {
          await this.getAccHoldingUnits(item.deductions[i], item)
        }
        return item
      } else {
        return item
      }
    },

    async setActiveSale (item, index) {
      const sale = await this.EditAllocation(item)

      this.currentSale = sale
      this.currentIndex = index

      this.getBalances(this.currentSale.CustodialID)
      this.getAccounts(this.currentSale.CustodialID)
      this.getHoldingUnits(this.currentSale)
      this.retrieveSettlementDetails(this.currentSale.SaleDate)
      // this.getCharges(this.currentSale.InstrumentValue)
      // this.getTaxes(this.currentSale.InstrumentValue)
    },

    setActiveDeduction (item, index) {
      this.currentDeduction = item
      this.deductionIndex = index
    },
  },

  mounted () {
    UserService.isSellEquity().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedEquitySales", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.edit {
  background-color: #DBEFFA;
}

.v-btn {
  outline: none
}

/* .v-select__selections input {
  display: none;
} */

.Account {
  width: 300px;
}

.my-allocations-table{
  table-layout : fixed;
}

.table-text-field{
  width: 170px;
}

.headline {
  color:white
}
</style>
